/**
 * B.H. Copyright (c) 2026 Yemot HaMashiach Ltd.
 * All Rights Reserved.
 *
 * This software is the confidential and proprietary information of
 * Yemot HaMashiach Ltd. ("Confidential Information"). You shall not
 * disclose such Confidential Information and shall use it only in
 * accordance with the terms of the license agreement you entered into
 * with Yemot HaMashiach Ltd.
 *
 * Unauthorized copying of this file, via any medium, is strictly prohibited.
 */
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { getLang } from '../Helper';

/**
 * המסכים עולים **בשפה של הלקוח**, ולא בעברית שמתוקנת אחר כך.
 *
 * `lng: 'he'` קשיח היה כאן, ומי שתיקן אותו היה ה-`Header` בלבד - ב-`useEffect` עם
 * השהיה, כלומר אחרי שהמסך כבר צויר. שני דברים נשברו בגללו:
 *
 *   1. **מסך ההתחברות הסלולרי אינו מצויר בתוך `Frame`**, ולכן אין לו `Header` כלל -
 *      והוא נשאר בעברית לכל אורכו, לכל לקוח, בלי שום דרך לשנות.
 *   2. כותרת `lang` נשלחה מ-`getLang()` - כלומר משפת הדפדפן - בעוד שהמסך הציג עברית.
 *      השרת זורע ממנה את שפת הלקוח (`users_preferences`), ולכן נרשם דובר אנגלית ראה
 *      מסכי הרשמה בעברית ונחת באזור האישי באנגלית. אותו לקוח, שתי שפות.
 *
 * `getLang()` כאן הוא בדיוק המקור ששולח את הכותרת, ולכן מה שמוצג ומה שנשלח הם אותו
 * ערך - מעכשיו בנקודה אחת, לפני שנוצר המסך הראשון.
 */
const initialLang = getLang();

i18n.use(initReactI18next).init({
  fallbackLng: 'en',
  lng: initialLang,
  resources: {
    en: {
      translations: require('./locales/en/translations.json')
    },
    he: {
      translations: require('./locales/he/translations.json')
    }
  },
  ns: ['translations'],
  defaultNS: 'translations'
});

i18n.languages = ['en', 'he'];

export default i18n;
